import { render, staticRenderFns } from "./DeleteCoverages.vue?vue&type=template&id=799e9bc2"
import script from "./DeleteCoverages.vue?vue&type=script&lang=js"
export * from "./DeleteCoverages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports